import { useEffect } from 'react'

import useGetOrganization from '~/features/organizations/hooks/useGetOrganization'
import { EOrgFeatureStatus } from '~/features/organizations/models'
import { store } from '~/store'

const useUpdateOrganizationStore = () => {
  const [organizationId, setOrganization] = store((state) => [
    state.user.organizationId,
    state.setOrganization,
  ])

  const {
    data: orgData,
    isSuccess,
    isLoading: isLoadingOrganization,
  } = useGetOrganization(organizationId)
  useEffect(() => {
    if (isSuccess && orgData.data) {
      setOrganization({
        paymentTier: orgData.data.paymentTier,
        referralCode: orgData.data.referralCode ?? '',
        featureCodes:
          orgData.data.OrgFeature?.filter(
            (orgFeature) =>
              orgFeature.status !== EOrgFeatureStatus.cancelled &&
              orgFeature.Feature.active,
          ).map((orgFeature) => orgFeature.Feature.code) ?? [],
      })
    }
  }, [isSuccess, orgData, setOrganization, organizationId])

  return isLoadingOrganization
}

export default useUpdateOrganizationStore
